import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import {IntlProvider} from "react-intl";
import configureStore from './store/configureStore.js';
import AppContainer from './containers/AppContainer';
import 'bootstrap/dist/css/bootstrap.css';
import './css/vendor/font-awesome/css/font-awesome.css';
require(`./assets/${process.env.PAGE}/css/form.css`)
import messages_ftyc from "./translations/ftyc.json";
import messages_fiduciaria from "./translations/fiduciaria.json";
import cuyoaval from "./translations/cuyoaval.json";
import cuyoaval_cheque from "./translations/cuyoavalcheque.json";

const messages = {
	'ftyc': messages_ftyc,
	'fiduciaria': messages_fiduciaria,
	'cuyoaval': cuyoaval,
	'cuyoavalcheque': cuyoaval_cheque,
};

const store = configureStore();

ReactDOM.render(
	<IntlProvider locale={'en'} messages={messages[process.env.PAGE]}>
	    <Provider store={store}>
	        <AppContainer/>
	    </Provider>
	</IntlProvider>,

    document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/